import { Component } from '@angular/core';
import { RelatorioApresentacaoComponent } from '../relatorio-apresentacao/relatorio-apresentacao.component';

@Component({
  selector: 'app-financiamento-atual-necessario-wrapper',
  standalone: true,
  imports: [RelatorioApresentacaoComponent],
  template: `
    <app-relatorio-apresentacao
      [breadcrumb]="'Financiamento atual x necessário'"
      [breadcrumbColor]="'#7FA6BF'"
      [iconeHero]="'assets/ilustrations/escola.svg'"
      [subtituloHero]="'Módulo'"
      [corSubtituloHero]="'#F36D2A'"
      [tituloHero]="'Financiamento atual x necessário'"
      [corTituloHero]="'#F36D2A'"
      [descricaoHero]="'Quanto custa uma escola pública em condições de qualidade? Este módulo calcula o orçamento necessário para financiar a educação de um conjunto de escolas de uma rede.'"
      [textoBotaoHero]="'Acessar simulação'"
      [corBotaoHero]="'transparent'"
      [corTextoBotaoHero]="'#F36D2A'"
      [linkBotaoHero]="'/filtrar-instituicoes'"
      [imagemHero]="'assets/imagens/children-teacher-book.png'"
      [backgroundHero]="'assets/ilustrations/circles-background-1.png'"
      [infoIcone]="infoIcons"
      [infoTexto]="infoTexts"
      [tituloCta]="'Que tal simular o orçamento necessário para a sua escola?'"
      [textoBotaoCta]="'Comece a usar'"
      [corBotaoCta]="'#F36D2A'"
      [corTextoBotaoCta]="'#fff'"
      [linkBotaoCta]="'/filtrar-instituicoes'"
      [corSetaHero]="'#F36D2A'"
      [corSetaCta]="'#FFF'"
    ></app-relatorio-apresentacao>
  `
})
export class FinanciamentoAtualNecessarioApresentacaoWrapperComponent {
  infoIcons = [
    { img: 'assets/ilustrations/plano-rede-municipal.svg', text: 'Plano para a rede municipal', color: '#F36D2A' },
  ];
  infoTexts = [
    {
      html: 'Este módulo apresenta estimativas do orçamento da despesa necessária para financiar o Padrão de Qualidade de Referência (PQR) para as redes públicas estaduais e municipais e compara essa despesa projetada com a Receita Potencial mínima Vinculada à Educação (RPEB). Como resultado, identifica as redes que precisam de complementação para financiar uma oferta de ensino em condições de qualidade, bem como seu montante. Igualmente, apresenta o Valor aluno CAQ/ano e Valor aluno CAQ/mês para cada rede pública, além de outras características das redes.<br><br>' +
        'É fundamental considerar que resultados são determinados pelos parâmetros que compõem o PQR e que estes são aplicados aos dados de oferta de cada uma das escolas públicas estaduais e municipais contidas no recorte territorial considerado na consulta (Brasil, estado ou município). Portanto, no SimCAQ, a escola é a unidade de análise dos custos. Veja os parâmetros que compõem o PQR 2025 (Disponível em <a href="/pqr" class="text-orange-400" style="text-decoration: underline; cursor: pointer;">simcaq.ufg.br/pqr</a>).',
      color: '#444'
    },
    {
      html: 'As informações deste relatório são relevantes para analisar a capacidade de financiamento de cada rede gerada pelos mecanismos de financiamento vigentes vis-à-vis a demanda por recursos gerada pela estimativa de despesa baseada no PQR para cada localidade. Além disso, permite análise a comparação do Valor aluno CAQ/ano com o Valor Aluno Ano Total (VAAT) do Fundeb, entre outras análises.<br><br>' +
        'Este conjunto de informações está disposto em uma planilha que pode ser baixada. Clique <a href="assets/20240705_dicionario_variaveis_rel_3.xlsx" download class="text-orange-400" style="text-decoration: underline; cursor: pointer;">aqui</a> para acessar o dicionário de variáveis da planilha de dados.<br><br>' +
        'Para realizar uma consulta, siga as seguintes etapas:<br>' +
        '1. Selecione o escopo da consulta (Brasil, Estado ou Município);<br>' +
        '2. Clique no botão "simular" para acessar o relatório síntese "Financiamento atual x necessário";<br>' +
        '3. Na tela do relatório "Financiamento atual x necessário" você pode baixar a planilha de dados de cada rede pública.',
      color: '#444'
    }
  ];
} 